import { render, staticRenderFns } from "./ClientPropositionPolicy.vue?vue&type=template&id=71858572&"
import script from "./ClientPropositionPolicy.vue?vue&type=script&lang=js&"
export * from "./ClientPropositionPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports